import React from 'react'
import { Link } from 'react-router-dom'
import fimg1 from '../../images/features/img-1.png'
import fimg2 from '../../images/features/img-2.png'
import fimg3 from '../../images/features/img-3.png'

import './style.css'

const Features = (props) => {

    const feature = [
        {
          cIcon:'fi flaticon-startup',
          cImg:fimg1,
          heading:"Faster Loading Speed",
          pra:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt .",
        },
        {
          cIcon:'fi flaticon-label',
          cImg:fimg2,
          heading:"99% Uptime Guarantee",
          pra:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt .",
          cl:'wpo-features-item-2'
        },
        {
          cIcon:'fi flaticon-support',
          cImg:fimg3,
          heading:"24/7 Customer Support",
          pra:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt .",
        },
    ]

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
    return(
        <div className={props.fClass}>
            <div className="container">
                <div className={props.bundle}>
                    <div className="row">
                        {feature.map((ftr, fitem) => (
                            <div className="col-lg-4 col-md-6 custom-grid col-12" key={fitem}>
                                <div className={`wpo-features-item ${ftr.cl}`}>
                                    <div className="wpo-features-single">
                                        <div className="wpo-features-icon">
                                            <i className={ftr.cIcon}></i>
                                        </div>
                                        <div className="wpo-features-text">
                                            <h2>{ftr.heading}</h2>
                                            <p>{ftr.pra}</p>
                                            <Link onClick={ClickHandler} to="/service-single">See More...</Link>
                                        </div>
                                    </div>
                                    <div className="wpo-features-img">
                                        <img src={ftr.cImg} alt="shape"/>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features;